import { render, staticRenderFns } from "./MxDataTable.vue?vue&type=template&id=1b34879e"
import script from "./MxDataTable.vue?vue&type=script&lang=ts"
export * from "./MxDataTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports